<template>
  <div class="userManage-container">
    <el-tabs
      class="userManage-tabs"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane label name></el-tab-pane>
      <el-tab-pane label="所有用户" name="allUser">
        <user-list></user-list>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="组织部门" name="second">
        <org-dept></org-dept>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="角色" name="third">
        <role></role>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UserList from "./components/UserList.vue";
import OrgDept from "./components/OrgDept.vue";
import role from "./components/role.vue";
export default {
  name: "UserManage",
  components: {
    UserList,
    OrgDept,
    role,
  },
  data() {
    return {
      activeName: "allUser",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>

<style lang='scss' scoped>
.userManage-container {
  height: calc(100% - 40px);
  margin: 20px;
  .userManage-tabs {
    height: 100%;
    ::v-deep .el-tabs__header {
      margin-bottom: 20px;
      background: #fff;
    }
    ::v-deep .el-tabs__content {
      height: calc(100% - 75px);
      background: #fff;
    }
  }
}
</style>